import type { LocationQuery } from 'vue-router';
import type { ProductFiltersModel } from '../model';
import { ROUTE_ONLY_QUERY_KEYS, isTrackingQueryKey } from '../constants';
import { isDefined } from '~/utils/guards/isDefined';
import { ensureArray } from '~/utils/ensureArray';

export function createFiltersFromQuery(
  query: LocationQuery
): ProductFiltersModel {
  const options: ProductFiltersModel = {};

  for (const key in query) {
    // Skip page-UI and tracking params. Magento facet allowlisting
    // (knownFilterCodes) still drops residual junk after aggregations load.
    // https://gcp.baslerweb.com/jira/browse/WEB2-2323
    if (ROUTE_ONLY_QUERY_KEYS.has(key) || isTrackingQueryKey(key)) {
      continue;
    }

    const value = query[key];
    if (!isDefined(value)) {
      continue;
    }

    options[key] = ensureArray(value)
      .filter(isDefined)
      .map((value) => value.toString());
  }

  return Object.fromEntries(
    Object.entries(options).filter(([_, value]) => value.length > 0)
  );
}
